import { ReactNode } from "react";
import { getThemeStyles, Theme } from '../../../../../../util/style';

type ColorVariant = "blue" | "green" | "orange" | "purple";

const colorMap: Record<ColorVariant, { text: string; bgDark: string; bgLight: string }> = {
    blue: {
        text: "text-blue-600",
        bgDark: "bg-blue-100",
        bgLight: "bg-blue-900"
    },
    green: {
        text: "text-green-600",
        bgDark: "bg-green-100",
        bgLight: "bg-green-900"
    },
    orange: {
        text: "text-orange-600",
        bgDark: "bg-orange-100",
        bgLight: "bg-orange-900"
    },
    purple: {
        text: "text-purple-600",
        bgDark: "bg-purple-100",
        bgLight: "bg-purple-900"
    },
};

export default function StatCard({
    theme = "light",
    title,
    value,
    icon,
    color = "blue",
}: {
    theme?: Theme;
    title: string;
    value: number | string;
    icon: ReactNode;
    color?: ColorVariant;
}) {
    const s = getThemeStyles(theme);
    const c = colorMap[color];

    return (
        <div className={`${s.card} rounded-xl shadow-lg p-6`}>
            <div className="flex items-center justify-between">
                <div>
                    <p className="text-sm font-medium">{title}</p>
                    <p className={`text-2xl font-bold ${c.text}`}>
                        {value}
                    </p>
                </div>

                <div className={`${theme === "dark" ? c.bgLight : c.bgDark} p-3 rounded-xl`}>
                    <div className={c.text}>
                        {icon}
                    </div>
                </div>
            </div>
        </div>
    );
}